import { useEffect } from 'react'

import { useAuthUser } from '~/hooks/useAuthUser'
import { setExtensionSessionInfo } from '~/utils/splitsConnectExtension'

// Mirrors the signed-in user to the splits-connect extension popup whenever
// auth resolves or the profile changes, and clears it when auth resolves
// signed out. Sign-out needs no explicit hook-in: useClearAuth removes the
// token and empties the query cache, so the user resolving to undefined here
// covers explicit logout and 401-driven clears alike.
export const useSyncExtensionSessionInfo = () => {
  const { user, initialLoadingState } = useAuthUser()

  const isSignedIn = Boolean(user)
  const name = user?.displayName
  const email = user?.email
  const avatarUrl = user?.profilePhotoUrl

  // eslint-disable-next-line local/noUseEffect -- mirroring auth state into an external system (the extension's storage) is synchronization an effect must do
  useEffect(() => {
    if (initialLoadingState) return
    setExtensionSessionInfo(
      isSignedIn ? { user: { name, email, avatarUrl } } : null,
    )
  }, [initialLoadingState, isSignedIn, name, email, avatarUrl])
}
